import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { Trash2, UserPlus } from "lucide-react";
import { toast } from "sonner";

export default function Persons() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", mobile: "" });
  const [submitting, setSubmitting] = useState(false);

  const load = async () => {
    try { const { data } = await api.get("/persons"); setItems(data); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail) || e.message); }
  };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault(); setSubmitting(true);
    try {
      await api.post("/persons", { name: form.name.trim(), mobile: form.mobile.trim() || null, active: true });
      toast.success("Person added"); setForm({ name: "", mobile: "" }); await load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || e.message); }
    finally { setSubmitting(false); }
  };

  const del = async (id) => {
    if (!window.confirm("Delete person? Will deactivate if in use.")) return;
    try { await api.delete(`/persons/${id}`); toast.success("Done"); await load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail) || e.message); }
  };

  return (
    <div className="space-y-8">
      <div>
        <Link to="/settings" className="label-eyebrow hover:text-ink transition-colors">← Settings</Link>
        <h1 className="font-heading text-4xl font-bold mt-1">Persons</h1>
        <p className="text-sm text-muted mt-1">Staff & contacts who receive suspense advances.</p>
      </div>
      <Card className="p-6 border border-line">
        <form onSubmit={add} className="flex items-end gap-4 flex-wrap">
          <div className="flex-1 min-w-[200px]"><Label className="label-eyebrow">Name</Label>
            <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required data-testid="person-name" className="mt-1.5" /></div>
          <div><Label className="label-eyebrow">Mobile</Label>
            <Input value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })} data-testid="person-mobile" className="mt-1.5 font-mono" /></div>
          <Button type="submit" disabled={submitting} data-testid="add-person-btn" className="bg-ink text-white"><UserPlus size={16} className="mr-1.5" /> Add</Button>
        </form>
      </Card>
      <Card className="overflow-hidden border border-line">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="bg-paper-alt border-b border-line">
              <th className="text-left px-4 py-3 label-eyebrow">Name</th>
              <th className="text-left px-4 py-3 label-eyebrow">Mobile</th>
              <th className="text-left px-4 py-3 label-eyebrow">Status</th>
              <th className="w-20"></th>
            </tr></thead>
            <tbody data-testid="persons-rows">
              {items.map(p => (
                <tr key={p.id} className="border-b border-line hover:bg-paper/60">
                  <td className="px-4 py-3 font-medium">{p.name}</td>
                  <td className="px-4 py-3 font-mono text-xs text-muted">{p.mobile || "—"}</td>
                  <td className="px-4 py-3"><span className={`text-xs px-2 py-0.5 rounded ${p.active ? "bg-cashin-bg text-cashin" : "bg-paper-alt text-muted"}`}>{p.active ? "Active" : "Inactive"}</span></td>
                  <td className="px-4 py-3"><button onClick={() => del(p.id)} className="text-muted hover:text-cashout"><Trash2 size={16} /></button></td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={4} className="px-4 py-12 text-center text-muted">No persons yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
